/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_S2Inputs */

const en_mk_tut_apr_s2 = /** @type {(inputs: Mk_Tut_Apr_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent’s request appears under **Approvals** with a preview of exactly what it would do.`)
};

const id_mk_tut_apr_s2 = /** @type {(inputs: Mk_Tut_Apr_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan agen muncul di menu **Approval** beserta pratinjau persis apa yang akan dilakukan.`)
};

/**
* | output |
* | --- |
* | "The agent’s request appears under **Approvals** with a preview of exactly what it would do." |
*
* @param {Mk_Tut_Apr_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_s2 = /** @type {((inputs?: Mk_Tut_Apr_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_s2(inputs)
	return en_mk_tut_apr_s2(inputs)
});